import { FleetVehicleTire, FleetVehicleTireRow } from "./types";

export const transformFleetVehicleTireRow = (res: any): FleetVehicleTireRow => {
  return {
    id: res.id,
    width: res.width,
    height: res.height,
    radius: res.radius,
    tireType: res.tireType,
    tireManufacturer: res.tireManufacturer,
    dot: res.dot,
    profileDepth: res.profileDepth,
    rof: res.rof,
    axlePosition: res.axlePosition ?? null,
    warehouse: res.warehouse,
    vehicle: res.vehicle,
    created: res.created
  };
};

export const transformFleetVehicleTire = (res: any): FleetVehicleTire => {
  return {
    id: res.id,
  };
};


